import type { FC } from 'react'
import { memo } from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@app/components/ui/button'
import CardSection from '@app/shared/cards/components/cardSection'
import type { CardSize } from '@app/types'
import ICON_MAP from '@app/utils/iconMap'

interface Props {
  title?: string
  link: string
  size: CardSize
}

const CardGoalsCTA: FC<Props> = ({ title = 'Set goal', link, size, ...rest }) => (
  <CardSection size={size} bgColor={{ base: 'teal.100', _dark: 'bg.panel' }}>
    <Button w="full" variant="solid" colorPalette="teal" asChild {...rest}>
      <Link to={link}>
        <ICON_MAP.OKR />
        {title}
      </Link>
    </Button>
  </CardSection>
)

export default memo(CardGoalsCTA)
